<template>

<form id="userForm" class="mx-auto col-sm-12" @submit.prevent>

  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('fantasy_name') }">
      <label for="fantasy_name">{{ $t('fantasy_name') }}</label>
      <input
        type="text"
        id="fantasy_name"
        name="fantasy_name"
        class="form-control"
        :placeholder="$t('type_fantasy_name')"
        v-model="garage.fantasyName"
        v-validate="'required'"
        @input="upper('fantasyName')"
      >
      <small v-show="errors.has('fantasy_name')" class="form-text text-muted">
        {{ errors.first('fantasy_name') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('social_reason') }">
      <label for="social_reason">{{ $t('social_reason') }}</label>
      <input
        type="text"
        id="social_reason"
        name="social_reason"
        class="form-control"
        :placeholder="$t('type_social_reason')"
        v-model="garage.socialReason"
        v-validate="'required'"
        @input="upper('socialReason')"
      >
      <small v-show="errors.has('social_reason')" class="form-text text-muted">
        {{ errors.first('social_reason') }}
      </small>
    </div>

    <CpfCnpjInput
      v-model="garage.cpfCnpj"
      :type.sync="documentType"
      class="col-lg-4"
    />
  </div>

  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('email') }">
      <label for="email">{{ $t('email') }}</label>
      <input
        type="email"
        class="form-control"
        id="email"
        name="email"
        :placeholder="$t('type_email')"
        v-model="garage.email"
        v-validate="'required|email'"
      >
      <small v-show="errors.has('email')" class="form-text text-muted">
        {{ errors.first('email') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('phone1') }">
      <label for="phone1">{{ $t('phone') }} 1</label>
      <the-mask
        type="text"
        id="phone1"
        name="phone1"
        class="form-control"
        :placeholder="$t('type_phone') + ' ' + 1"
        v-model="garage.phone1"
        v-validate="'min:10|max:12'"
        :mask="['(##) ####-####', '(##) #####-####']"
      />
      <small v-show="errors.has('phone1')" class="form-text text-muted">
        {{ errors.first('phone1') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('phone2') }">
      <label for="phone2">{{ $t('phone') }} 2</label>
      <the-mask
        type="text"
        id="phone2"
        name="phone2"
        class="form-control"
        :placeholder="$t('type_phone') + ' ' + 2"
        v-model="garage.phone2"
        v-validate="'min:10|max:12'"
        :mask="['(##) ####-####', '(##) #####-####']"
      />
      <small v-show="errors.has('phone2')" class="form-text text-muted">
        {{ errors.first('phone2') }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('cep') }">
      <label for="cep">{{ $t('cep') }}</label>
      <div class="input-group">
        <the-mask
          type="text"
          id="cep"
          name="cep"
          class="form-control"
          :placeholder="$t('type_cep')"
          v-model="garage.cep"
          v-validate="'required|digits:8'"
          :mask="'#####-###'"
        />
        <div class="input-group-append">
          <button
            class="btn btn-primary"
            type="button"
            @click="searchCep"
          >
            <i class="fas fa-search" />
          </button>
        </div>
      </div>
      <small v-show="errors.has('cep')" class="form-text text-muted">
        {{ errors.first('cep') }}
      </small>
    </div>

    <div class="form-group col-lg-4">
      <label for="uf">{{ $t('uf') }}</label>
        <Combobox
          class="bg-white"
          name='uf'
          :hasErrors="errors.has('uf')"
          :placeholder="$t('select_a_item')"
          :options="ufs"
          :initial-value="garage.uf"
          v-model="garage.uf"
          v-validate="'required'"
        />

      <small v-show="errors.has('uf')" class="form-text text-muted">
        {{ errors.first('uf') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('city') }">
      <label for="city">{{ $t('city') }}</label>
      <input
        type="text"
        id="city"
        name="city"
        class="form-control"
        :placeholder="$t('type_city')"
        v-model="garage.city"
        v-validate="'required'"
        @input="upper('city')"
      >
      <small v-show="errors.has('city')" class="form-text text-muted">
        {{ errors.first('city') }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('public_place') }">
      <label for="public_place">{{ $t('public_place') }}</label>
      <input
        type="text"
        id="public_place"
        name="public_place"
        class="form-control"
        :placeholder="$t('type_public_place')"
        v-model="garage.publicPlace"
        v-validate="'required'"
        @input="upper('publicPlace')"
      >
      <small v-show="errors.has('public_place')" class="form-text text-muted">
        {{ errors.first('public_place') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('neighborhood') }">
      <label for="neighborhood">{{ $t('neighborhood') }}</label>
      <input
        type="text"
        id="neighborhood"
        name="neighborhood"
        class="form-control"
        :placeholder="$t('type_neighborhood')"
        v-model="garage.neighborhood"
        v-validate="'required'"
        @input="upper('neighborhood')"
      >
      <small v-show="errors.has('neighborhood')" class="form-text text-muted">
        {{ errors.first('neighborhood') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('establishment_number') }">
      <label for="establishment_number">{{ $t('establishment_number') }}</label>
      <input
        type="text"
        id="establishment_number"
        name="establishment_number"
        class="form-control"
        :placeholder="$t('type_establishment_number')"
        v-model="garage.establishmentNumber"
        v-validate="'required'"
      >
      <small v-show="errors.has('establishment_number')" class="form-text text-muted">
        {{ errors.first('establishment_number') }}
      </small>
    </div>
  </div>

  <div class="row">
  </div>

  <div class="form-group">
    <label for="users">{{ $t('users') }}</label>

    <Multiselect
      :items="users"
      :initialSelected="garage.users"
      itemValue="id"
      itemText="name"
      @move="onMoveUsers"
    />
  </div>

  <div class="row">
    <div class="form-group col-lg-4">
      <label for="place_service">{{ $t('place_service') }}</label>
        <Combobox
          class="bg-white"
          name='place_service'
          :placeholder="$t('select_a_item')"
          :options="placeServices"
          v-model="garage.placeService"
          :initial-value="garage.placeService"
        />
    </div>

    <div class="col-lg-4 form-group" :class="{ 'has-error': errors.has('latitude') }">
      <label for="latitude">{{ $t('latitude') }}</label>
      <div class="input-group">
        <input
          type="text"
          id="latitude"
          name="latitude"
          class="form-control"
          :placeholder="$t('ph_latitude')"
          v-model="garage.latitude"
        >

        <div class="input-group-append">
          <button
            type="button"
            class="btn btn-primary"
            @click="searchCoords"
          >
            <i class="fas fa-search" />
          </button>
        </div>
      </div>
      <small v-show="errors.has('latitude')" class="form-text text-muted">
        {{ errors.first('latitude') }}
      </small>
    </div>

    <div class="col-lg-4 form-group" :class="{ 'has-error': errors.has('longitude') }">
      <label for="longitude">{{ $t('longitude') }}</label>
      <input
        type="text"
        id="longitude"
        name="longitude"
        class="form-control"
        :placeholder="$t('ph_longitude')"
        v-model="garage.longitude"
      >
      <small v-show="errors.has('longitude')" class="form-text text-muted">
        {{ errors.first('longitude') }}
      </small>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('installation_value') }">
      <label for="installation_value">{{ $t('installation_value') }}</label>
      <CurrencyInput
        v-model="garage.installationValue"
        :auto-decimal-mode="true"
        :distraction-free='false'
        currency='BRL'
        locale='pt-BR'
        class="demo__currency-input form-control"
      />

      <small v-show="errors.has('installation_value')" class="form-text text-muted">
        {{ errors.first('installation_value') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('reinstallation_value') }">
      <label for="reinstallation_value">{{ $t('reinstallation_value') }}</label>
      <CurrencyInput
        v-model="garage.reinstallationValue"
        :auto-decimal-mode="true"
        :distraction-free='false'
        currency='BRL'
        locale='pt-BR'
        class="demo__currency-input form-control"
      />

      <small v-show="errors.has('reinstallation_value')" class="form-text text-muted">
        {{ errors.first('reinstallation_value') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('maintance_value') }">
      <label for="maintance_value">{{ $t('maintance_value') }}</label>
      <CurrencyInput
        v-model="garage.maintanceValue"
        :auto-decimal-mode="true"
        :distraction-free='false'
        currency='BRL'
        locale='pt-BR'
        class="demo__currency-input form-control"
      />

      <small v-show="errors.has('maintance_value')" class="form-text text-muted">
        {{ errors.first('maintance_value') }}
      </small>
    </div>
  </div>

  <div class="row">

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('withdrawal_value') }">
      <label for="withdrawal_value">{{ $t('withdrawal_value') }}</label>
      <CurrencyInput
        v-model="garage.withdrawalValue"
        :auto-decimal-mode="true"
        :distraction-free='false'
        currency='BRL'
        locale='pt-BR'
        class="demo__currency-input form-control"
      />

      <small v-show="errors.has('withdrawal_value')" class="form-text text-muted">
        {{ errors.first('withdrawal_value') }}
      </small>
    </div>

    <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('km_traveled_value') }">
      <label for="km_traveled_value">{{ $t('km_traveled_value') }}</label>
      <CurrencyInput
        v-model="garage.kmTraveledValue"
        :auto-decimal-mode="true"
        :distraction-free='false'
        currency='BRL'
        locale='pt-BR'
        class="demo__currency-input form-control"
      />

      <small v-show="errors.has('km_traveled_value')" class="form-text text-muted">
        {{ errors.first('km_traveled_value') }}
      </small>
    </div>

    <div class="form-group col-lg-4">
      <div class="switch">
        <label for="isActive">{{ $t('active') }}</label>
        <div class="onoffswitch2">
          <input
            type="checkbox"
            class="onoffswitch2-checkbox"
            id="isActive"
            v-model="garage.isActive">
          <label class="onoffswitch2-label" for="isActive">
              <span class="onoffswitch2-inner"></span>
              <span class="onoffswitch2-switch"></span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton @click="onClick">
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>

</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Multiselect from '@/components/form/Multiselect.vue'
import Combobox from '@/components/shared/ComboBox.vue'
import uf from '@/config/uf.js'
import placeService from '@/config/place-services'
import CpfCnpjInput from '@/components/shared/CpfCnpjInput.vue'

export default {
  name: 'GarageAccreditedForm',
  components: {
    LoaderButton,
    Multiselect,
    Combobox,
    CpfCnpjInput
  },
  data: () => ({
    ufs: uf,
    placeServices: placeService,
    documentType: 'cpf'
  }),
  props: {
    garage: {
      type: Object,
      default: () => ({
        id: undefined,
        fantasyName: '',
        socialReason: '',
        cpfCnpj: '',
        cep: undefined,
        uf: '',
        city: '',
        publicPlace: '',
        neighborhood: '',
        establishmentNumber: '',
        phone1: '',
        phone2: '',
        email: '',
        users: [],
        placeService: '',
        latitude: '',
        longitude: '',
        installationValue: 0,
        reinstallationValue: 0,
        maintanceValue: 0,
        withdrawalValue: 0,
        kmTraveledValue: 0,
        isActive: true
      })
    }
  },
  watch: {
    'garage.cpfCnpj': {
      immediate: true,
      handler(value) {
        if (!value) return

        const doc = String(value).replace(/[^A-Za-z0-9]/g, '')

        this.documentType = doc.length === 14 ? 'cnpj' : 'cpf'
      }
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.all
    })
  },
  methods: {
    ...mapActions('garageaccredited', [
      'create',
      'edit',
      'cleanState'
    ]),

    onMoveUsers (users) {
      this.garage.users = users.map(({ id }) => id)
    },

    customLabel (option) {
      return option.name
    },

    async onClick (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { id } = this.garage

      let promise

      id
        ? promise = this.edit({ id, data: this.garage })
        : promise = this.create(this.garage)

      const result = await promise

      if (result) this.$router.push({ name: 'listgarageaccrediteds' })
    },

    upper(attribute) {
      this.garage[attribute] = this.garage[attribute].toUpperCase()
    },

    searchCep() {
      const { cep } = this.garage

      if (cep.length < 8) return

      fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.garage.publicPlace = data.logradouro
          this.garage.neighborhood = data.bairro
          this.garage.city = data.localidade
          this.garage.uf = data.uf
        })
    },

    searchCoords() {
      const { cep, city, publicPlace, neighborhood, establishmentNumber } = this.garage

      fetch(`https://geocode.search.hereapi.com/v1/geocode?q=
        ${publicPlace}%2C+
        ${establishmentNumber}%2C+
        ${cep}%2C+
        ${city}%2C+
        Brasil
        &apiKey=${process.env.VUE_APP_HERE_KEY}
      `)
        .then(response => response.json())
        .then(data => {
          if (data.items[0]) {
            this.garage.latitude = data.items[0].position.lat
            this.garage.longitude = data.items[0].position.lng
          } else {
            this.garage.latitude = ''
            this.garage.longitude = ''
          }
        })
    }
  },
  async mounted () {
    await Promise.all([
      this.$store.dispatch('users/fetchPartners')
    ])
  },
  destroyed () {
    this.$store.dispatch('users/cleanState')
    this.cleanState()
  }
}
</script>
